import "moment-timezone";
import React, { Component } from "react";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import Alert from "react-s-alert";
import AuthContext from "../auth-context";
import Pagination from "../Shared/pagination";
import PhoneNumber from "../Shared/PhoneNumber";
import LeadsService from "../utils/LeadsService";

class List extends Component {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    const authStore = this.context;
    this.isRestrictedCoach = authStore.hasRole("coach_restricted");
    this.state = {
      filter: { view: "list", assigned: "", lead_type: "" },
      leads: [],
      users: props.users,
      currentPage: 1,
      totalPages: 1,
      per: 50,
      view: props.view
    };

    this.onPageChange = this.onPageChange.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props !== prevProps) {
      if (this.props.match.params.view !== prevProps.match.params.view) {
        this.setState(
          { view: this.props.view, currentPage: 1 },
          this.fetchLeads
        );
      }
      if (this.props.users !== prevProps.users) {
        this.setState({ users: this.props.users });
      }
    }
  }

  componentDidMount() {
    this.setState({ loadingInProgress: true }, this.fetchLeads);
  }

  onPageChange(currentPage) {
    this.setState({ currentPage }, () => this.fetchLeads());
  }

  handleFilterChange(event) {
    let filter = { ...this.state.filter };
    filter[event.target.id] = event.target.value;
    this.setState({ filter: filter, currentPage: 1 }, this.fetchLeads);
  }

  fetchLeads() {
    LeadsService.index({
      view: this.state.view,
      filter: this.state.filter,
      page: this.state.currentPage,
      per: this.state.per
    }).then(data => {
      let leads = data.results;
      this.setState({
        loadingInProgress: false,
        leads: leads,
        totalCount: data.total_count,
        totalPages: Math.ceil(data.total_count / this.state.per)
      });
    });
  }

  handleAssignedChange(leadId, event) {
    this.setState({ actionInProgress: true });
    LeadsService.takeAction("assign", leadId, {
      email: event.target.value
    }).then(response => {
      const leads = JSON.parse(JSON.stringify(this.state.leads));
      const index = leads.findIndex(e => {
        return e.id === leadId;
      });
      leads[index].assigned_to = response.lead.assigned_to;
      this.setState({ leads: leads, actionInProgress: false });
      Alert.success(`Assigned to ${response.lead.assigned_to || "nobody"}`);
    });
  }

  render() {
    const List = props => {
      return (
        <tbody>
          {props.leads.map(lead => (
            <ListItem key={lead.id} lead={lead} />
          ))}
        </tbody>
      );
    };

    const ListItem = props => {
      const titleCase = str => {
        if (!str) return str;
        return str.replace(/_/g, " ").replace(/\w\S*/g, function(txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
      };

      const { lead } = props;
      return (
        <tr key={props.index}>
          <td>#{lead.id}</td>
          <td>
            <Link to={`/m1/follow_ups/${lead.id}`}>{lead.first_name}</Link>
          </td>
          <td>
            <Link to={`/m1/follow_ups/${lead.id}`}>{lead.email}</Link>
          </td>
          <td>
            <PhoneNumber number={lead.mobile}></PhoneNumber>
          </td>
          <td>
            {lead.due_at ? (
              <Moment format="dddd h:mma MMM Do YYYY">{lead.due_at}</Moment>
            ) : (
              "No Due Date"
            )}
          </td>
          <td>
            <select
              id="assigned"
              disabled={this.state.actionInProgress}
              onChange={event => this.handleAssignedChange(lead.id, event)}
              defaultValue={lead.assigned_to}
            >
              <option value="">(not assigned)</option>
              {this.state.users.map(user => (
                <option key={user.email} value={user.email}>
                  {user.name}
                </option>
              ))}
            </select>
          </td>
          <td>{titleCase(lead.lead_type)}</td>
          <td>
            {lead.lead_type === "dead_deal"
              ? titleCase(lead.dead_deal_reason)
              : lead.lead_type === "could_not_present_tcs"
              ? titleCase(lead.not_presented_reason)
              : ""}
          </td>
        </tr>
      );
    };
    return (
      <div>
        <div className="row" style={{ marginBottom: "10px" }}>
          <div className="col-sm-9">
            {!this.isRestrictedCoach && (
              <select
                style={{ marginRight: 10 }}
                id="assigned"
                value={this.state.filter.assigned}
                onChange={this.handleFilterChange}
              >
                <option value="">(assigned to anyone)</option>
                <option value="unassigned">(NOT assigned)</option>
                {this.state.users.map(user => (
                  <option key={user.email} value={user.email}>
                    {user.name}
                  </option>
                ))}
              </select>
            )}

            <select
              style={{ marginRight: 10 }}
              id="lead_type"
              value={this.state.filter.lead_type}
              onChange={this.handleFilterChange}
            >
              <option value="">(all types)</option>
              <option value="could_not_present_tcs">
                Couldn’t present TCS
              </option>
              <option value="could_not_confirm_tcs">
                Couldn’t confirm TCS
              </option>
              <option value="seminar_attended_did_not_book">
                Seminar attended, did not book TCS
              </option>
              <option value="seminar_register_did_not_attend">
                Booked Seminar, did not attend
              </option>
              <option value="other">Other</option>
            </select>

            <select
              style={{ marginRight: 10 }}
              id="booking_from"
              value={this.state.filter.booking_from}
              onChange={this.handleFilterChange}
            >
              <option value="">(all sources)</option>
              <option value="seminar">Seminar</option>
              <option value="web">Web</option>
              <option value="call_centre">Call Centre</option>
              <option value="m1office">M1 Office</option>
            </select>

            <select
              style={{ marginRight: 10 }}
              id="business_stream"
              value={this.state.filter.business_stream}
              onChange={this.handleFilterChange}
            >
              <option value="">(all streams)</option>
              <option value="seminar">Seminar</option>
              <option value="web">Web Booking</option>
              <option value="expo">Expo</option>
              <option value="callcentre">Call Centre</option>
              <option value="work_experience_directory">
                Work Experience Directory
              </option>
              <option value="free_report">Free Report</option>
              <option value="seminar_confirmation_call">
                Seminar Confirmation Call
              </option>
              <option value="seminar_no_show">Seminar No Show Call</option>
              <option value="seminar_attended_didnt_book">
                Seminar Attended But Didnt Book
              </option>
              <option value="referral">Referral</option>
              <option value="other">Other</option>
            </select>
          </div>
          <div className="col-sm-3">
            {this.state.totalPages > 1 && (
              <div className="pull-right">
                <Pagination
                  currentPage={this.state.currentPage}
                  totalPages={this.state.totalPages}
                  onChange={this.onPageChange}
                />
              </div>
            )}
          </div>
        </div>

        {this.state.leads.length === 0 ? (
          <div>No matches</div>
        ) : (
          <table className="table table-hover table-bordered">
            <thead className="dark">
              <tr>
                <th style={{ width: 10 }}>ID</th>
                <th colSpan="3">Parent</th>
                <th>Due At</th>
                <th>Assigned To</th>
                <th>Type</th>
                <th>Reason</th>
              </tr>
            </thead>
            <List leads={this.state.leads} />
          </table>
        )}
      </div>
    );
  }
}

export default List;
